import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userSlice from "./features/UserSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import projectSlice from "./features/ProjectSlice";
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'

export const Types = {
    SIGNOUT_REQUEST: 1,
}

const reducers = combineReducers({
    user: userSlice.reducer,
    projects: projectSlice.reducer
})

const rootReducer = (state, action) => {
    if (action.type === Types.SIGNOUT_REQUEST) {
        storage.removeItem('persist:root')

        return reducers(undefined, action);
    }
    return reducers(state, action)
}

const persistConfig = {
    key: 'root', storage
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
})